"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = noopMiddleware;
/**
 * A no-op middleware, does nothing :)
 * @param req
 * @param res
 * @param next
 */
function noopMiddleware(req, res, next) {
    next();
}
